module.exports = __webpack_public_path__ + "img/icono-watch.8f42b9ef.svg";